import { GetterTree } from "vuex";
import { ILevelState } from "./levels-types";
import { RootState } from "../root-state";
import { ILevel } from "@/services/data/level/level.interface";
import { generateBaseGettersFor } from "../utils/base-generators";

export const getters: GetterTree<ILevelState, RootState> = {
  ...generateBaseGettersFor<ILevelState, ILevel>("levels"),
};
